import { useHistory } from "react-router-dom";
export default function CheckFrontLogin() {
  const history = useHistory();
  if (localStorage.getItem("front_location_id") === null) {
    history.push("/front/login");
  }
}
